var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 15.7279 8.27208 18.75 12 18.75C15.7279 18.75 18.75 15.7279 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z",
    fill: "#282728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1601 7.25C12.5743 7.25 12.9101 7.58579 12.9101 8V12.7727C12.9101 13.1869 12.5743 13.5227 12.1601 13.5227C11.7459 13.5227 11.4101 13.1869 11.4101 12.7727V8C11.4101 7.58579 11.7459 7.25 12.1601 7.25Z",
    fill: "#282728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8357 13.0985C12.6557 13.4716 12.2074 13.6282 11.8343 13.4483L8.27422 11.7314C7.90112 11.5515 7.74453 11.1032 7.92445 10.7301C8.10437 10.357 8.55268 10.2004 8.92578 10.3803L12.4859 12.0972C12.859 12.2771 13.0156 12.7254 12.8357 13.0985Z",
    fill: "#282728"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineClock);
export default __webpack_public_path__ + "static/media/line-clock.2ac6f41d0030a425f82fc8e9673b2a56.svg";
export { ForwardRef as ReactComponent };